import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

import { accessToken } from "../Utility";
import { SpinnerLoading } from "../components/Loadings";
import envFile from "../envFile";
import awsmobile from "../aws-exports";

const UpdateEmailVerification = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { token } = useParams();

  useEffect(() => {
    userVerify();
  }, []);

  const userVerify = async () => {
    try {
      setLoading(true);
      const res = await accessToken();

      const response = await axios.post(
        `${envFile.PUBLIC_API_LINK}/updateEmail`,
        {
          userPoolId: awsmobile.aws_user_pools_id,
          token: token,
        },
        {
          headers: {
            Authorization: res.data.access_token,
          },
        }
      );

      if (response?.data?.status === 500) {
        toast.error(response?.data?.response);
      } else if (response?.data?.status === 200) {
        toast.success(response?.data?.response);
      }
      navigate("/");
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
      toast.error("Something went wrong!");
    }
  };
  return (
    <div>
      {loading && (
        <div className="loadingSpinner">
          <SpinnerLoading />
        </div>
      )}
    </div>
  );
};

export default UpdateEmailVerification;
